import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse } from '@boma/administration-portal/shared/entities';
import { IRole } from '@boma/administration-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listRoles(
    page: string = '1',
    perPage: string = '25',
    query: string = '',
    target: string = '0'
  ) {
    return this.httpClient.get<IPaginatedResponse<IRole>>(
      `${this.base}api/v${this.version}/Roles`,
      {
        params: { page, query, perPage, target },
      }
    );
  }

  createRole(role: IRole) {
    return this.httpClient.post<IRole>(
      `${this.base}api/v${this.version}/Roles`,
      {
        ...role,
      }
    );
  }

  loadRoleDetails(roleId: string) {
    return this.httpClient.get<IRole>(
      `${this.base}api/v${this.version}/Roles/${roleId}`
    );
  }

  getTargetPermissions(target: string) {
    return this.httpClient.get<string[]>(
      `${this.base}api/v${this.version}/Permissions/${target}`
    );
  }

  updateRole(role: IRole, roleId: string) {
    return this.httpClient.put<IRole>(
      `${this.base}api/v${this.version}/Roles/${roleId}`,
      {
        ...role,
      }
    );
  }

  deleteRole(roleId: string) {
    return this.httpClient.delete<HttpResponse<any>>(
      `${this.base}api/v${this.version}/Roles/${roleId}`
    );
  }
}
